module.exports = {
  taxRate: 0.07,
  restaurantID: "XBpi9tCHHhHiR1W7Dzfs",
  isDeliveryRestaurant: true,
  isReservationRestaurant: false,
  restaurantName: "Chopstick Express",
  url: "https://www.chopstickfl.com/"
};
